module.exports = __webpack_public_path__ + "img/queue.49f45183.svg";